import { IEventTelemetry, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ai } from './telemetry.service';

// Error thrown when an unexpected null reference is passed.
export function trackGmcException(message: string): void {
  ai.getApplicationInsights().trackException({
    exception: new Error(`GMC call failed: ${message}`),
    severityLevel: SeverityLevel.Error
  });
}

// Error thrown when an unexpected null reference is passed.
export function trackNullValueException(message: string): void {
  ai.getApplicationInsights().trackException({
    exception: new Error(`Unexpected null value: ${message}`),
    severityLevel: SeverityLevel.Error
  });
}

// Error thrown when an HTML element does not render as expected.
export function trackHTMLNotVisibleException(caseId: string, innerHtml: string): void {
  ai.getApplicationInsights().trackException({
    exception: new Error(`Rendered HTML is not visible: CaseId=${caseId} HTML=${innerHtml}`),
    severityLevel: SeverityLevel.Error
  });
}

// Generic error tracking
export function trackException(error: Error): void {
  ai.getApplicationInsights().trackException({
    exception: error,
    severityLevel: SeverityLevel.Error
  });
}

// Generic warning tracking
export function trackWarning(message: string): void {
  ai.getApplicationInsights().trackException({
    exception: new Error(`Warning: ${message}`),
    severityLevel: SeverityLevel.Warning
  });
}

// Generic info tracking
export function trackInfo(message: string): void {
  ai.getApplicationInsights().trackException({
    exception: new Error(`Info: ${message}`),
    severityLevel: SeverityLevel.Information
  });
}

export function trackEvent(
  message: string,
  data?: {
    [key: string]: any;
  }
): void {
  ai.getApplicationInsights().trackEvent(
    {
      name: message
    } as IEventTelemetry,
    data
  );
}
